<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <header class="card-header">
            <strong class="align-self-center">{{
              $t("sectionAtendimento.atendimentoTitle")
            }}</strong>
          </header>
          <div v-if="loading" class="loading-container">
            <RotateSquare
              class="loading-position animated fadeIn"
              size="60px"
            ></RotateSquare>
          </div>
          <div v-else class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-5 col-xl-4">
                <div class="form-group">
                  <label for>{{
                    $t("sectionAtendimento.atendimentoNome")
                  }}</label>
                  <input
                    v-model="filtro.nome"
                    class="form-control"
                    type="text"
                  />
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-5 col-xl-4">
                <div class="form-group">
                  <label for>{{
                    $t("sectionAtendimento.atendimentoTel")
                  }}</label>
                  <input
                    v-model="filtro.telefone"
                    class="form-control"
                    type="text"
                  />
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-5 col-xl-4">
                <div class="form-group">
                  <label for>{{
                    $t("sectionAtendimento.atendimentoTipo")
                  }}</label>
                  <select v-model="filtro.tipo" class="form-control" required>
                    <option selected value>
                      {{ $t("sectionAtendimento.atendimentoSelecione") }}
                    </option>
                    <option value="1">WhatsApp</option>
                    <option value="3">E-mail</option>
                    <option value="4">Instagram</option>
                    <option value="2">Facebook</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-5 col-xl-3">
                <div class="form-group">
                  <label for>{{
                    $t("sectionAtendimento.atendimentoStatus")
                  }}</label>
                  <select v-model="filtro.status" class="form-control" required>
                    <option selected value>
                      {{ $t("sectionAtendimento.atendimentoSelecione") }}
                    </option>
                    <option value="1">
                      {{ $t("sectionAtendimento.atendimentoEmAtendimento") }}
                    </option>
                    <option value="2">
                      {{ $t("sectionAtendimento.atendimentoCancelado") }}
                    </option>
                    <option value="3">
                      {{ $t("sectionAtendimento.atendimentoConcluido") }}
                    </option>
                  </select>
                </div>
              </div>
              <div
                class="col-sm-12 col-md-6 col-lg-5 col-xl-3"
                title="Selecione um ou mais usuários"
              >
                <div class="form-group">
                  <label for>{{
                    $t("sectionAtendimento.atendimentoUsuario")
                  }}</label>
                  <v-select
                    v-model="filtro.usuarios"
                    :placeholder="$t('sectionAtendimento.atendimentoSelecione')"
                    :options="usuarioOptions"
                    multiple
                  >
                    <template slot="no-options">
                      {{ $t("sectionAtendimento.atendimentoNenhumResultado") }}
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-5 col-xl-3">
                <div class="form-group">
                  <label for>{{ $t("sectionMotivo.motivo") }}</label>
                  <v-select v-model="filtro.motivos" :placeholder="$t('sectionMotivo.selecione')"
                    :options="motivosOptions" @search:focus="getMotivosSelect2" multiple>
                    <template slot="no-options">
                      {{ $t("sectionAttendance.pleaseWaitNoResultsForYourSearch") }}
                    </template>
                  </v-select>
                </div>
              </div>
              <div
                class="col-sm-12 col-md-3 col-lg-2 col-xl-2">
                <div class="form-group">
                  <label for>{{ $t("sectionMotivo.possuiComentario") }}</label>
                  <b-form-checkbox v-model="filtro.possuiComentario" name="check-button" switch>
                    {{ $t("textYes") }}
                  </b-form-checkbox>
                  
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <button
                    class="btn btn-primary mr-2"
                    type="button"
                    @click="Filtrar()"
                  >
                    {{ $t("sectionAtendimento.atendimentoBtFiltrar") }}
                  </button>
                  <button
                    class="btn btn-secondary"
                    type="button"
                    @click="Limpar()"
                  >
                    {{ $t("sectionAtendimento.atendimentoBtLimpar") }}
                  </button>
                </div>
              </div>
            </div>

            <b-table
              :hover="true"
              responsive
              :items="itens"
              :fields="fields"
              striped
              :per-page="itensPorPagina"
              show-empty
              :empty-text="$t('textNenhumResultado')"
            >
              <template v-slot:empty="scope">
                <h4>{{ scope.emptyText }}</h4>
              </template>
              <template v-slot:cell(dataAbertura)="data">
                <div class="center">
                  <label for>{{
                    new Date(data.item.dataAbertura).toLocaleString()
                  }}</label>
                </div>
              </template>
              <template v-slot:cell(dataFechamento)="data">
                <div v-if="data.item.dataFechamento" class="center">
                  <label for>{{
                    new Date(data.item.dataFechamento).toLocaleString()
                  }}</label>
                </div>
                <div v-else class="center">
                  <label for>{{ data.item.dataFechamento }}</label>
                </div>
              </template>
              <template v-slot:cell(motivoComentario)="data">
                  <span :title=data.item.motivoComentario>{{truncateText(data.item.motivoComentario)}}</span>
              </template>
              <template v-slot:cell(tipo)="data">
                <div class="center">
                  <span class="badge">{{ ObterTipoNome(data.item.tipo) }}</span>
                </div>
              </template>
              <template v-slot:cell(status)="data">
                <div class="center">
                  <span :class="ObterBadgeStatus(data.item.status)">{{
                    ObterStatusNome(data.item.status)
                  }}</span>
                </div>
              </template>
              <template v-slot:cell(acoes)="data">
                <div class="btn-group-sm">
                  <b-button
                  v-if="data.item.status == 3 && !data.item.avaliado"
                    variant="success"
                    style="margin-right: 10px;"
                    :title="$t('sectionPesquisaSatisfacao.enviarPesquisa')"
                    @click="EnviarPesquisa(data.item)"
                  >
                  <i class="far fa-heart" style="color: black;"></i>
                  </b-button>
                  <b-button
                    variant="warning"
                    style="margin-right: 10px;"
                    :title="$t('btEditar')"
                    @click="Editar(data.item)"
                  >
                    <i class="fa fa-edit" style="color: black;"></i>
                  </b-button>
                  <b-button
                    variant="danger"
                    :title="$t('btRemover')"
                    @click="Remover(data.item)"
                  >
                    <i class="fas fa-trash-alt" style="color: black;"></i>
                  </b-button>
                </div>
              </template>
            </b-table>
            <b-pagination
              v-model="pagina"
              :total-rows="total"
              :per-page="itensPorPagina"
              align="right"
              size="md"
              class="mt-2"
            ></b-pagination>
            <b-modal
              v-model="modalRemover"
              :title="$t('textConfirmaExclusaoAfirmacao')"
              header-bg-variant="danger"
              ok-variant="danger"
              @ok="ModalOk"
              @hidden="ModalCancel"
            >
              {{ $t("infoMessages.confirmTheDeletionOfThisRecord") }}
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import TipoAtendimento from "../../enums/TipoAtendimento";
import StatusAtendimento from "../../enums/StatusAtendimento";
import TipoPerfil from "../../enums/TipoPerfil";

export default {
  name: "Atendimento",
  components: {
    RotateSquare
  },
  data() {
    return {
      locale: this.$i18n.locale,
      modalRemover: false,
      itemRemover: null,
      loading: false,
      usuarioOptions: [],
      itens: [],
      pagina: 1,
      total: 0,
      itensPorPagina: 0,
      motivosOptions:[],
      filtro: {
        nome: "",
        tipo: "",
        status: "",
        telefone: "",
        contaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
        pagina: 1,
        usuarios: null,
        locale: this.$i18n.locale,
        motivos: null,
        possuiComentario:false
      }
    };
  },
  computed: {
    fields() {
      return [
        {
          key: "nome",
          label: this.$t("sectionAtendimento.atendimentoNome"),
          sortable: true
        },
        {
          key: "identificador",
          label: this.$t("sectionOrcamento.orcamentoIdentificador"),
          sortable: true
        },
        {
          key: "usuarioNome",
          label: this.$t("sectionAtendimento.atendimentoUsuario"),
          sortable: true
        },
        {
          key: "dataAbertura",
          label: this.$t("sectionAtendimento.atendimentoAbertura"),
          sortable: true
        },
        {
          key: "dataFechamento",
          label: this.$t("sectionAtendimento.atendimentoFechamento"),
          sortable: true
        },
        {
          key: "motivos",
          label: this.$t("sectionMotivo.motivo"),
          sortable: true
        },
        {
          key: "motivoComentario",
          label: this.$t("sectionMotivo.comentario"),
          sortable: true
        },
        {
          key: "tipo",
          label: this.$t("sectionAtendimento.atendimentoTipo"),
          sortable: true
        },
        {
          key: "status",
          label: this.$t("sectionAtendimento.atendimentoStatus"),
          sortable: true
        },
        {
          key: "acoes",
          label: this.$t("sectionAtendimento.atendimentoAcoes"),
          sortable: false,
          thClass: "center, wd-120-px"
        }
      ];
    }
  },
  watch: {
    locale(val) {
      this.$i18n.locale = val;
    },
    pagina(pagina) {
      this.ObterGrid(pagina);
    }
  },
  mounted() {
    this.ObterGrid(1);
    this.ObterUsuarioSelect2();
  },
  methods: {
    getMotivosSelect2() {
      this.$http({
        url:
          "/motivos/obter-select2/" +
          this.$store.getters.getAutenticacao.contaSelecionadaId,
        method: "GET"
      })
        .then((response) => {
          this.motivosOptions = response.data;
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    truncateText(text) {
      if (typeof text === 'string' && text.length > 20) {
          return text.substring(0, 20) + '...';
      } else {
          return text;
      }
    },
    ObterUsuarioSelect2() {
      this.loading = true;
      this.$http({
        url:
          "/usuario/obter-select2/" +
          this.$store.getters.getAutenticacao.contaSelecionadaId,
        method: "GET"
      })
        .then((response) => {
          this.loading = false;
          this.usuarioOptions = response.data;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    ObterBadgeStatus(status) {
      switch (status) {
        case StatusAtendimento.EmAtendimento:
          return "badge badge-info";
        case StatusAtendimento.Cancelado:
          return "badge badge-danger";
        case StatusAtendimento.Concluido:
          return "badge badge-success";
        default:
          return "badge badge-secondary";
      }
    },
    ObterStatusNome(status) {
      switch (status) {
        case StatusAtendimento.EmAtendimento:
          return this.$t("textEmAtendimento");
        case StatusAtendimento.Cancelado:
          return this.$t("textCancelado");
        case StatusAtendimento.Concluido:
          return this.$t("textConcluido");
        default:
          return this.$t("textNenhum");
      }
    },
    ObterTipoNome(tipo) {
      switch (tipo) {
        case TipoAtendimento.WhatsApp:
          return "WhatsApp";
        case TipoAtendimento.Facebook:
          return "Facebook";
        case TipoAtendimento.Email:
          return "E-mail";
        case TipoAtendimento.Instagram:
          return "Instagram";
        default:
          return "";
      }
    },
    Limpar() {
      this.filtro.nome = "";
      this.filtro.tipo = "";
      this.filtro.status = "";
      this.filtro.telefone = "";
      this.filtro.usuarios = [];
      this.filtro.motivos = [];
      this.ObterGrid(1);
    },
    Filtrar() {
      this.ObterGrid(1);
    },
    Editar(usuario) {
      this.$router.push("/atendimento/editar/" + usuario.id);
    },
    EnviarPesquisa(atendimento){
      this.loading = true;
      this.$http({
        url:
          "/pesquisa-satisfacao/enviar/" +
          this.$store.getters.getAutenticacao.contaSelecionadaId +
          "/" +
          atendimento.id,
        method: "GET"
      })
        .then((response) => {
          const pesquisaComSucesso = this.$t(
                        "sectionPesquisaSatisfacao.enviadaSucesso"
                    );

                    this.$notify({
                        data: [pesquisaComSucesso],
                        type: "success",
                        duration: 10000
                    });
          this.loading = false;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: [erro.response.data],
            type: "warn",
            duration: 10000
          });
        });
    },
    ModalCancel(evento) {
      evento.preventDefault();
      this.itemRemover = null;
    },
    ModalOk(evento) {
      evento.preventDefault();
      this.modalRemover = false;
      if (!this.itemRemover) return;

      let podeRemover =
        this.itemRemover.usuarioId ===
          this.$store.getters.getAutenticacao.usuarioId ||
        this.$store.getters.getAutenticacao.perfil ===
          TipoPerfil.Administrador ||
        this.$store.getters.getAutenticacao.perfil === TipoPerfil.Sistema;
      if (!podeRemover) {
        const attendanceCannotBeRemoved = this.$t(
          "infoMessages.attendanceCannotBeRemoved"
        );
        const serviceDoesNotBelongToTheAuthenticatedUser = this.$t(
          "infoMessages.serviceDoesNotBelongToTheAuthenticatedUser"
        );

        this.$notify({
          data: [
            attendanceCannotBeRemoved,
            serviceDoesNotBelongToTheAuthenticatedUser
          ],
          type: "warn",
          duration: 10000
        });
        this.itemRemover = null;
        return;
      }
      var tipoContatoDelete = this.ObterTipoContatoApi(this.itemRemover.tipo)
      this.$http({
        url:
          "atendimento/remover/" +
          this.itemRemover.id +
          "/" +
          this.$store.getters.getAutenticacao.contaSelecionadaId +
          "/" +
          tipoContatoDelete,
        method: "DELETE"
      })
        .then(() => {
          this.ObterGrid(1);
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    Remover(item) {
      this.modalRemover = true;
      this.itemRemover = item;
    },
    ObterTipoContatoApi(tipo){
      switch (tipo) {
        case TipoAtendimento.WhatsApp:
          return 0;
        case TipoAtendimento.Facebook:
          return 2;
        case TipoAtendimento.Instagram:
          return 1;
        default:
          return 0;
      }
    },
    ObterGrid(pagina) {
      this.loading = true;
      this.filtro.pagina = pagina;
      this.$http({
        url: "/atendimento/obter-grid/",
        data: this.filtro,
        method: "POST"
      })
        .then((response) => {
          this.loading = false;
          this.itens = response.data.itens;
          this.total = response.data.total;
          this.pagina = response.data.pagina;
          this.itensPorPagina = response.data.itensPorPagina;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    }
  }
};
</script>
<style>
.margin-top-filter-button {
  margin-top: 29px;
}
</style>
